export const AreaOptionData = {
    "9": "9",
    "12": "12",
    // "16": "16",
    "18": "18",
    "27": "27",
    "36": "36",
    "54": "54",
    "72": "72",
    // "90": "90",
    "108": "108",
}

export const HALL_KEYS_CONSTANT_DATA = {
    "Pavillion": "Pavillion",
    // "h1": "h1",
    // "h2": "h2",
    // "h3": "h3",
    // "h4": "h4",
    // "h5": "h5",
    // "h6": "h6",
    // "h7": "h7",
}
export const HALL_CONSTANT_DATA = {
    [HALL_KEYS_CONSTANT_DATA.Pavillion]: "Pavillion",
    // [HALL_KEYS_CONSTANT_DATA.h1]: "Hall 1 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h2]: "Hall 2 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h3]: "Hall 3 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h4]: "Hall 4 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h5]: "Hall 5 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h6]: "Hall 6 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.h7]: "Hall 7 - BIEC",
}
export const AREA_HALL_MAPPING = {
    "6": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "9": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "12": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    // "16": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "18": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    // "24": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "27": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "36": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    // "48": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "54": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    // "60": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "72": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
    "108": [HALL_KEYS_CONSTANT_DATA.Pavillion,],
}
